
export enum SocialLinksURLEnum {
  FACEBOOK = 'facebook.com/',
  INSTAGRAM = 'instagram.com/',
  LINKEDIN = 'linkedin.com/in/',
  XING = 'xing.com/profile/',
  WEBSITE = '',
  TWITTER = 'twitter.com/',
}
